module.exports = __webpack_public_path__ + "files/abb12fc254db7db04627ecccf005eba6.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Script-Regular.ttf
// module id = 824
// module chunks = 60